import React from 'react'

import { Navbar, RightPlanet} from './components'
import {Footer} from "./container/index"
import { AnimatePresence } from "framer-motion";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.scss'
import ShoppingCart from "./assets/images/Announce.png"
import Announcement from 'react-announcement'
import Loading from './Loading';
//Components
const Home = lazy(() => import('./pages/Home'));
const Story = lazy(() => import('./pages/Story'));
const Product = lazy(() => import('./pages/Product'));
const Partner = lazy(() => import('./pages/Partner'));

const App = () => {
    return (
      <>
      <Suspense fallback={<Loading />}>
      <AnimatePresence exitBeforeEnter>
        <Router>
          <div className='app'>
           <Announcement
          title="電商連接告知"
          subtitle="宇宙波波周邊商品與電商建置中，敬請期待，欲購買商品請洽詢客服相關連結"
          link=""
          imageSource={ShoppingCart}
          daysToLive={1}
          secondsBeforeBannerShows={1}
          closeIconSize={30}
      />
            <Navbar/>
    <RightPlanet/>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={Story} />
                <Route exact path="/product" component={Product} />
                <Route exact path="/partner" component={Partner} />
              </Switch>   
            <Footer/>
        </div>
        </Router>
     </AnimatePresence>
        </Suspense>
        </>
    )
}

export default App
